export const comments_3899723 = {"data":{"data":[],"links":{}}}